export default "__VITE_ASSET__DluTJCVB__"